import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=0c9afd36&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isPage"
import style0 from "./index.mpx?vue&type=style&index=0&id=0c9afd36&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_3f63ba8a%22%7D&isPage"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports